import { render, staticRenderFns } from "./MyQuotationCroDetail.vue?vue&type=template&id=6d3ff6e6&scoped=true&"
import script from "./MyQuotationCroDetail.vue?vue&type=script&lang=js&"
export * from "./MyQuotationCroDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotationCroDetail.vue?vue&type=style&index=0&id=6d3ff6e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ff6e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d3ff6e6')) {
      api.createRecord('6d3ff6e6', component.options)
    } else {
      api.reload('6d3ff6e6', component.options)
    }
    module.hot.accept("./MyQuotationCroDetail.vue?vue&type=template&id=6d3ff6e6&scoped=true&", function () {
      api.rerender('6d3ff6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/MyQuotationCroDetail.vue"
export default component.exports